import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../../common/GridLayout";
import { FillFilters, getAppSettings } from '../../../../common/Utils';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import { SearchLayout } from './Layout';
import { CrateProfileRoutes, DELPHI_DATE_TIME_FORMAT } from '../../../../const/constants';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import '../../../../common/css/searchPage.css';

// Find screen for the Delphi form uWMD0064 "IM Crates Data Profile Entry" (browse of IMCRATESDP).
// Accordion search panel driven by the shared dynamic form, plus a results grid whose layout is
// saved per user via GridLayoutManager. The grid is read-only - every write goes through Form.js -
// so the store needs no insert/update/delete urls and no concurrency-aware wrapper.

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    // Honor the "Collapse Filter Panel" application setting: collapsed -> no item selected,
    // expanded -> the first (and only) search-filter panel is selected.
    const filtersCollapsed = !!getAppSettings()?.FiltersCollapsed;
    const [selectedItems, setSelectedItems] = useState(filtersCollapsed ? [] : [searchpanel[0]]);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000];
    const gridKey = "037BE15D-D449-4782-8625-7A1F4F05E709";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    // One key per SearchLayout field, hidden ones included: FillFilters only ever sees what is in
    // formFields, so a field the dynamic-form customiser un-hides has to already have a key here or
    // it would silently never filter - and Reset has to be able to clear it.
    const initialFormFields = {
        recordNumber: '',
        profileCode: '',
        description: '',
        userDefinedCode1: '',
        userDefinedCode2: '',
        userDefinedCode3: '',
        userDefinedCode4: '',
        userDefinedCode5: ''
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const [resultData, setResultData] = useState(null);

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
        },
        [selectedItems, setSelectedItems],
    );

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length === 1) {
            rowId.current = selectedRowsData[0].RowId;
            setIsEditButtonDisabled(false);
        } else {
            rowId.current = null;
            setIsEditButtonDisabled(true);
        }
    };

    const handleEditClick = () => {
        history.push(`${CrateProfileRoutes.Edit}?rowid=${rowId.current}`);
    };

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();

        // Every criterion on this panel maps to a string column, so FillFilters' ["<field>",
        // "contains", value] shape applies to all of them - unlike the Item Data Profile screen,
        // which has to pull its one numeric field out. COMMENT is deliberately not a criterion: it is
        // a SQL Server `text` column and "contains" compiles to CHARINDEX, which it rejects.
        const filters = FillFilters(formFields);

        datasource.filter(filters.length === 0 ? null : filters);
        setResultData(datasource);
    };

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setTimeout(() => {
            setResultData(loadDatasource());
        }, 100);
    };

    // FormField calls onFormLoad() unconditionally with no guard (FormField.js:256), so it is a
    // required prop. This panel has no static option lists to seed - the five code fields are server
    // lookups that fetch their own data - hence the no-op.
    const handleFormLoad = useCallback(() => {
    }, []);

    const handleFieldChange = useCallback((name, value) => {
    }, []);

    const loadDatasource = () => {
        let store = createStore({
            key: 'RowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.CrateProfile.GetCrateProfiles}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    useEffect(() => {
        if (!resultData) {
            setResultData(loadDatasource());
        }
    }, []);

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Crate Profiles
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='53961522-2B54-4C9D-9C81-50DCDB8E3E5C'
                                layoutName='WMCrateProfileSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="multiple" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    disabled={isEditButtonDisabled}
                                    onClick={handleEditClick}
                                    type="default"
                                    text="Edit"
                                ></Button>
                            </GridToolbarItem>
                            <GridToolbarItem location="before">
                                <div>
                                    <Link to={CrateProfileRoutes.Create}>
                                        <Button
                                            type="default"
                                            className="gridTopButton"
                                            text="Create"
                                        ></Button>
                                    </Link>
                                </div>
                            </GridToolbarItem>
                            <GridToolbarItem location="after">
                                <GridLayoutManager
                                    gridKey={gridKey}
                                    dataGrid={dataGrid}
                                    currentLayout={currentLayout}
                                    setCurrentLayout={setCurrentLayout}
                                    accessToken={accessToken}
                                />
                            </GridToolbarItem>
                            <GridToolbarItem name="columnChooserButton" />
                            <GridToolbarItem name="exportButton" />
                        </GridToolbar>

                        {/* Columns are the Delphi fields with VisibleOnGrid = True (uWMM0064.dfm),
                            plus Record # (rule 10). The five code columns are VisibleOnGrid but not
                            Visible, so they ship behind the column chooser rather than on screen. */}
                        <Column dataType="string" caption="Record #" dataField="RecordNumber" />
                        <Column dataType="string" caption="Profile" dataField="ProfileCode" />
                        <Column dataType="string" caption="Description" dataField="Description" />
                        <Column dataType="string" caption="Code 1" dataField="UserDefinedCode1" visible={false} />
                        <Column dataType="string" caption="Code 2" dataField="UserDefinedCode2" visible={false} />
                        <Column dataType="string" caption="Code 3" dataField="UserDefinedCode3" visible={false} />
                        <Column dataType="string" caption="Code 4" dataField="UserDefinedCode4" visible={false} />
                        <Column dataType="string" caption="Code 5" dataField="UserDefinedCode5" visible={false} />
                        {/* COMMENT is a SQL Server `text` column: it can be selected but not ordered
                            ("The text, ntext, and image data types cannot be compared or sorted"), so
                            sorting is disabled rather than left to fail. */}
                        <Column dataType="string" caption="Comment" dataField="Comment" allowSorting={false} visible={false} />

                        {/* Audit columns - the projection already carries them. */}
                        <Column dataType="datetime" caption="Creation Date" dataField="CreationDateTime" format={DELPHI_DATE_TIME_FORMAT} visible={false} />
                        <Column dataType="string" caption="Created By" dataField="CreationUserId" visible={false} />
                        <Column dataType="datetime" caption="Last Updated" dataField="LastUpdateDateTime" format={DELPHI_DATE_TIME_FORMAT} visible={false} />
                        <Column dataType="string" caption="Last Updated By" dataField="LastUpdateUserId" visible={false} />

                        {/* Technical columns stay hidden - users never see raw ids (rule 8). */}
                        <Column dataType="string" caption="RowId" dataField="RowId" visible={false} showInColumnChooser={false} />
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(List);
